
<div class="content-wrap">
	<div id="content" class="content admin_tool_content">		
		<div class="admin_team_body">
			<h3 class="teamWrapper">Add Project Team<span class="fw-semi-bold"></span></h3>
            <section class="widget widget_content">
                <header>
                    <h5 class="mb10 pt30">Please provide details below to add user to a project</h5>
                </header>
                <div class="widget-body">
                    <form class="form-horizontal" role="form">
                        <fieldset>
                            <div class="form-group">
                                <label for="normal-field" class="col-sm-2 control-label">LEED ID</label>
                                <div class="col-sm-7">
                                    <input [(ngModel)]="leed_id" name="leed_id" type="text" id="normal-field" class="form-control" placeholder="LEED ID">
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-2 control-label" for="prepended-input">User ID</label>
                                <div class="col-sm-7">
                                    <div class="input-group"><span class="input-group-addon"><i class="fa fa-user"></i></span>
                                        <input maxlength="40" [(ngModel)]="user_id" name="user_id" id="prepended-input" class="form-control" size="16" type="text" placeholder="User ID">
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-2 control-label" for="prepended-input">Role</label>
                                <div class="col-sm-7">
                                    <div class="dropdown">
                                        <button class="btn dropdown-toggle btn-default" type="button" data-toggle="dropdown" >
                                        <span>{{role}}</span>
                                        <span class="caret ml8"></span>
                                        </button>
                                        <ul class="dropdown-menu">
                                            <li (click)="changeRole('ARC Project Admin', 'ZRPO80')"><a>ARC Project Admin</a></li>
                                            <li (click)="changeRole('ARC Project Team Member', 'ZRPO81')"><a>ARC Project Team Member</a></li>
                                            <li (click)="changeRole('ARC Project Team Manager', 'ZRPO82')"><a>ARC Project Team Manager</a></li>
                                            <li (click)="changeRole('ARC Project Read Only', 'ARC01')"><a>ARC Project Read Only</a></li>
                                            <li (click)="changeRole('GBCI Reviewer', 'ARC02')"><a>GBCI Reviewer</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="form-group">
                                <label class="col-sm-2 control-label" for="prepended-input"></label>
                                <div class="col-sm-7">
                                    <div [ngClass]="loader ? 'not-active' : ''">
                                        <ul style="padding-left: 0px;" class="wizard display-block pull-left mr10">
                                            <li class="next list_style_none align-right">
                                                <button (click)="saveRole()" class="btn btn-default"><i class="fa fa-plus" aria-hidden="true"></i> Create</button>
                                            </li>
                                        </ul>
                                        <div *ngIf="loader" class="dataInputLoaderSpinner pull-left"></div>   
                                    </div>
                                </div>
                            </div>                            
                        </fieldset>
                    </form>
                </div>
            </section>
        </div>
        <div id="admin_team_body" class="pt30">
			<h3 class="teamWrapper admin_tool_content_portfolio">View/Delete Project Team<span class="fw-semi-bold"></span></h3>
            <section class="widget widget_content" [ngClass]="delete_loader ? 'not-active' : ''">
                <app-loader *ngIf="delete_loader"></app-loader>
                <header>
                    <h5 class="mb10 pt30">Enter Project ID to view team members</h5>
                </header>
                <div class="widget-body">
                    <form class="form-horizontal" role="form">
                        <fieldset>
                            <div class="form-group">
                                <label for="normal-field" class="col-sm-2 control-label">Project ID</label>
                                <div class="col-sm-7">                                    
                                    <!-- <input [(ngModel)]="delete_leed_id" type="text" id="normal-field" class="form-control" placeholder="LEED ID"> -->
                                    <input [(ngModel)]="delete_leed_id" name= "delete_leed_id" type="text" class="form-control" placeholder="Project ID">
                                </div>
                                <div class="wizard display-block">
                                    <button (click)="getTeam()" class="btn btn-default pull-left mr10"><i class="fa fa-search" aria-hidden="true"></i> Search</button>
                                </div>
                            </div>                    
                        </fieldset>
                    </form>

                    <table class="table table-striped table-hover no-footer">
                        <thead>
                            <tr>
                                <th>NAME</th>
                                <th>EMAIL</th>
                                <th>ACCESS</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let team_member of team_members; let idx = index" [hidden]="team_member.Responsibility == 'D'">
                                <td>{{team_member.Firstname}} {{team_member.Lastname}}</td>
                                <td>{{team_member.Useralias}}</td>
                                <td><span class="capitalize">{{team_member.Roledescription.toLowerCase()}}</span></td>
                                <td>
                                    <div [hidden]="team_member.Roleid == 'ZRPO03'" title="Remove User" class="ml10 delete_report floatNone" (click)="removeUser(team_member)"></div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>
        </div>
        <div id="admin_team_body" class="pt30">
            <h3 class="teamWrapper admin_tool_content_portfolio">Add Portfolio Team<span class="fw-semi-bold"></span></h3>
            <section class="widget widget_content">
                <header>
                    <h5 class="mb10 pt30">Please provide details below to add a user to a portfolio</h5>
                </header>
                <div class="widget-body">
                    <form class="form-horizontal" role="form">
                        <fieldset>
                            <div class="form-group">
                                <label for="normal-field" class="col-sm-2 control-label">Portfolio ID</label>
                                <div class="col-sm-7">
                                    <input [(ngModel)]="pf_id" name="pf_id" type="text" id="normal-field" class="form-control" placeholder="Portfolio ID">
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-2 control-label" for="prepended-input">User ID</label>
                                <div class="col-sm-7">
                                    <div class="input-group"><span class="input-group-addon"><i class="fa fa-user"></i></span>
                                        <input maxlength="40" [(ngModel)]="pf_user_id" name = "pf_user_id" id="prepended-input" class="form-control" size="16" type="text" placeholder="User ID">
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-2 control-label" for="prepended-input">Role</label>
                                <div class="col-sm-7">
                                    <div class="dropdown">
                                        <button class="btn dropdown-toggle btn-default" type="button" data-toggle="dropdown" >
                                        <span>{{pf_role}}</span>
                                        <span class="caret ml8"></span>
                                        </button>
                                        <ul class="dropdown-menu">
                                            <li (click)="changeRolePF('Can Read', 'can_read')"><a>Can Read</a></li>
                                            <li (click)="changeRolePF('Can Edit', 'can_edit')"><a>Can Edit</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="form-group">
                                <label class="col-sm-2 control-label" for="prepended-input"></label>
                                <div class="col-sm-7">
                                    <div [ngClass]="loader ? 'not-active' : ''">
                                        <ul style="padding-left: 0px;" class="wizard display-block pull-left mr10">
                                            <li class="next list_style_none align-right">
                                                <button (click)="saveRolePF()" class="btn btn-default"><i class="fa fa-plus" aria-hidden="true"></i> Create</button>
                                            </li>
                                        </ul>
                                        <div *ngIf="loader" class="dataInputLoaderSpinner pull-left"></div>
                                    </div>
                                </div>
                            </div>
                            
                        </fieldset>
                    </form>
                </div>
            </section>
        </div>
    </div>
</div>

